import { render } from "./Navbar.vue?vue&type=template&id=9c4bd33c"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=9c4bd33c&lang=scss"
script.render = render

export default script